import { Box, Flex, Text } from '@radix-ui/themes';
import { endOfYesterday, lightFormat } from 'date-fns';
import { t } from 'i18next';
import { LOCAL_DATE_FORMAT } from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const GameDataFooter = () => {
  return (
    <Flex justify="between" gap={RADIX.FLEX.GAP.SECTION}>
      <Box>
        <Text size={RADIX.TEXT.SIZE.XS}>
          {t('common.last-updated')}:{' '}
          {lightFormat(endOfYesterday(), LOCAL_DATE_FORMAT)}
        </Text>
      </Box>
      <Box>
        <Text size={RADIX.TEXT.SIZE.XS}>{t('common.mlb-copyright')}</Text>
      </Box>
    </Flex>
  );
};
